import { extendTheme } from "@chakra-ui/react";

const config = {
  initialColorMode: "system"
};

export default extendTheme({ config });
